import { combineReducers } from 'redux'
import * as types from '../../utils/actionTypes'
import { createReducer } from '../../utils/helpers'

const initialState = {
  plot: null,
  budget: null,
  nodes: [],
  client: {},
}


// Plot
const togglePlot = (state, payload) => (
  state === payload ? null : payload
)

export const plot = createReducer(initialState.plot, {
  [types.TOGGLE_PLOT_SELECTION]: togglePlot,
})


// Budget
const setBudget = (state, payload) => (
  payload
)

export const budget = createReducer(initialState.budget, {
  [types.SET_BUDGET_SELECTION]: setBudget,
})


// Nodes
const toggleNodes = (state, payload) => {
  const newState = [...state]
  payload.forEach((node) => {
    const index = newState.indexOf(node)
    if (index !== -1) {
      return newState.splice(index, 1)
    }
    return newState.push(node)
  })
  return newState
}

export const nodes = createReducer(initialState.nodes, {
  [types.TOGGLE_NODES_SELECTION]: toggleNodes,
})


// Offer
const setOffer = (state, payload) => ({
  ...payload,
})

export const client = createReducer(initialState.client, {
  [types.SET_CLIENT_SELECTION]: setOffer,
})


// Default Export
export default combineReducers({
  plot,
  budget,
  nodes,
  client,
})



// WEBPACK FOOTER //
// ./src/modules/selection/reducers.js